import type { Resident, Story, DonationGoal, Post } from '@zs/shared/schema';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

async function request<T>(endpoint: string): Promise<T> {
  const response = await fetch(`${API_URL}${endpoint}`);
  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }
  return response.json();
}

export async function fetchResidents(): Promise<Resident[]> {
  return request<Resident[]>('/api/residents');
}

export async function fetchResident(id: string): Promise<Resident | null> {
  try {
    return await request<Resident>(`/api/residents/${id}`);
  } catch {
    return null;
  }
}

export async function fetchGoals(): Promise<DonationGoal[]> {
  return request<DonationGoal[]>('/api/goals');
}

export async function fetchStories(): Promise<Story[]> {
  return request<Story[]>('/api/stories');
}

export async function fetchPosts(): Promise<Post[]> {
  return request<Post[]>('/api/posts');
}
